import dt from '~/domains/contest/domains/managev2/domains/common/testing.const';

import type { FormattedErrors } from '../../../context/utils/formatZodErrors';
import type { FormValues } from '../../../types/FormValues';

import type { TableColumnType, TableRowDataType, TableRowType } from './types';
import type { TableValue } from './types/common';
import { DescriptorsMap } from './constants';

export function TableCellSwitch({
  allErrors,
  allValues,
  cell,
  column,
  row,
  sectionKey,
  value,
  onChange,
}: {
  allErrors: FormattedErrors;
  allValues: FormValues;
  cell: TableRowDataType;
  column: TableColumnType;
  row: TableRowType;
  sectionKey: string;
  value: TableValue;
  onChange: (columnKey: string, newValue: unknown, skipTouched?: boolean) => void;
}) {
  const descriptor = DescriptorsMap[column.type];
  if (!descriptor) {
    // eslint-disable-next-line no-console
    console.log(`Unknown column type: '${column.type}'`);
    return null;
  }

  return (
    <td data-test-id={dt.table.body.cell}>
      <descriptor.Cell
        // @ts-expect-error Typescript can't infer column
        column={column}
        // @ts-expect-error Typescript can't infer cell
        cell={cell}
        row={row}
        value={value?.[row.key]?.[column.key]}
        allValues={allValues}
        allErrors={allErrors}
        sectionKey={sectionKey}
        onChange={(newValue, skipTouched?: boolean) => onChange(column.key, newValue, skipTouched)}
      />
    </td>
  );
}
